import React, { useState } from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { 
  LayoutDashboard, 
  Tv, 
  Tag, 
  Users, 
  CreditCard, 
  Settings, 
  BarChart3, 
  Wallet,
  Menu,
  X,
  Bot,
  Percent,
  Eye,
  Copy,
  Shield,
  Package,
  Megaphone,
  Gift,
  LogOut,
} from 'lucide-react';
import { setAdminToken } from '../lib/api';

// Order matches Emergent SubPay nav
const navItems = [
  { path: '/', icon: LayoutDashboard, label: 'Дашборд' },
  { path: '/channels', icon: Tv, label: 'Каналы' },
  { path: '/packages', icon: Package, label: 'Пакеты' },
  { path: '/tariffs', icon: Tag, label: 'Тарифы' },
  { path: '/subscriptions', icon: Users, label: 'Подписки' },
  { path: '/payments', icon: CreditCard, label: 'Платежи' },
  { path: '/payment-methods', icon: Wallet, label: 'Платежные системы' },
  { path: '/promo-codes', icon: Percent, label: 'Промокоды' },
  { path: '/broadcasts', icon: Megaphone, label: 'Рассылки' },
  { path: '/referrals', icon: Gift, label: 'Рефералы' },
  { path: '/auto-repost', icon: Copy, label: 'Авторепост' },
  { path: '/admins', icon: Shield, label: 'Администраторы' },
  { path: '/stats', icon: BarChart3, label: 'Статистика' },
  { path: '/settings', icon: Settings, label: 'Настройки бота' },
];

export const Layout = ({ children }) => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const location = useLocation();

  return (
    <div className="min-h-screen bg-[#050505]">
      {/* Mobile menu button */}
      <button
        data-testid="mobile-menu-btn"
        className="md:hidden fixed top-4 left-4 z-50 p-2 rounded-lg bg-[#0a0a0a] border border-white/5"
        onClick={() => setSidebarOpen(!sidebarOpen)}
      >
        {sidebarOpen ? <X className="w-5 h-5" /> : <Menu className="w-5 h-5" />}
      </button>

      {/* Sidebar */}
      <aside 
        className={`sidebar ${sidebarOpen ? 'open' : ''} md:translate-x-0`}
        data-testid="sidebar"
      >
        <div className="p-6 border-b border-white/5 shrink-0">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 rounded-lg bg-[#2AABEE]/10 flex items-center justify-center">
              <Bot className="w-6 h-6 text-[#2AABEE]" />
            </div>
            <div>
              <h1 className="font-bold text-lg text-white">SubPay</h1>
              <p className="text-xs text-zinc-500">Управление подписками</p>
            </div>
          </div>
        </div>

        <nav className="sidebar-nav p-4 space-y-1">
          {navItems.map((item) => {
            const isActive = location.pathname === item.path;
            return (
              <NavLink
                key={item.path}
                to={item.path}
                data-testid={`nav-${item.path.replace('/', '') || 'dashboard'}`}
                className={`flex items-center gap-3 px-4 py-3 rounded-lg text-sm font-medium transition-colors ${
                  isActive 
                    ? 'bg-[#2AABEE]/10 text-[#2AABEE] border-l-2 border-[#2AABEE]' 
                    : 'text-zinc-400 hover:text-white hover:bg-white/5'
                }`}
                onClick={() => setSidebarOpen(false)}
              >
                <item.icon className="w-5 h-5" />
                {item.label}
              </NavLink>
            );
          })}
        </nav>

        <div className="shrink-0 p-4 border-t border-white/5 bg-[#080808]">
          <a 
            href="/bot-preview" 
            target="_blank"
            className="flex items-center gap-3 px-4 py-3 rounded-lg text-sm font-medium bg-[#2AABEE]/10 text-[#2AABEE] hover:bg-[#2AABEE]/20 transition-colors mb-3"
          >
            <Eye className="w-5 h-5" />
            Превью бота
          </a>
          <div className="px-4 py-3 rounded-lg bg-white/5">
            <p className="text-xs text-zinc-500 mb-1">Версия</p>
            <p className="text-sm text-white font-mono">1.2.0</p>
          </div>
          <button
            type="button"
            data-testid="logout-btn"
            className="mt-3 flex w-full items-center gap-3 px-4 py-3 rounded-lg text-sm font-medium text-zinc-400 hover:text-white hover:bg-white/5"
            onClick={() => {
              setAdminToken('');
              window.location.assign('/login');
            }}
          >
            <LogOut className="w-5 h-5" />
            Выйти
          </button>
        </div>
      </aside>

      {/* Mobile overlay */}
      {sidebarOpen && (
        <div 
          className="md:hidden fixed inset-0 bg-black/50 z-40"
          onClick={() => setSidebarOpen(false)}
        />
      )}

      {/* Main content */}
      <main className="main-content">
        <div className="p-6 pt-16 md:p-8">
          {children}
        </div>
      </main>
    </div>
  );
};

export default Layout;
